import React, { useState } from 'react';
import { useFavorites } from '../context/FavoritesContext';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import { HeartIcon as SolidHeartIcon, ShoppingBagIcon } from '@heroicons/react/24/solid';
import { toast } from 'react-toastify';

const FavoriteProductCard = ({ product }) => {
  const { toggleFavorite } = useFavorites();
  const { addToCart } = useCart();
  const [selectedVariant, setSelectedVariant] = useState(product.variants && product.variants.length > 0 ? product.variants[0] : null);

  const handleAddToCart = () => {
    if (!selectedVariant) {
      toast.warn("Lütfen bir seçenek belirleyin.");
      return;
    }
    addToCart(product, selectedVariant, 1);
  };
  
  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col relative">
      <button onClick={() => toggleFavorite(product)} className="absolute top-3 right-3 z-10 bg-white/70 backdrop-blur-sm p-2 rounded-full">
        <SolidHeartIcon className="w-6 h-6 text-red-500" />
      </button>
      <Link to={`/products/${product.id}`}>
        <img src={product.main_image_url} alt={product.name} className="w-full h-64 object-cover rounded-t-xl" />
      </Link>
      <div className="p-4 flex flex-col flex-grow">
        <h2 className="font-bold text-lg text-text-dark">{product.name}</h2>
        <p className="text-xl font-bold text-brand-green mt-2 mb-4">₺{parseFloat(product.price).toFixed(2)}</p>
        
        {/* DÜZELTME: Varyant seçimi stilleri ve mantığı güncellendi */}
        {product.variants && product.variants.length > 1 && (
          <div className="mb-4">
            <label className="text-sm text-gray-600 mb-1 block">Seçenek:</label>
            <select 
              onChange={(e) => {
                const variant = JSON.parse(e.target.value);
                setSelectedVariant(variant);
              }}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green"
              value={JSON.stringify(selectedVariant)}
            >
              {product.variants.map((variant, index) => (
                <option key={index} value={JSON.stringify(variant)} disabled={variant.stock === 0}>
                  {variant.color} - {variant.size} {variant.stock === 0 && '(Tükendi)'}
                </option>
              ))}
            </select>
          </div>
        )}

        <button 
          onClick={handleAddToCart}
          className="w-full mt-auto bg-brand-green text-white font-bold py-2 px-4 rounded-lg hover:bg-brand-green-light transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
          disabled={!selectedVariant || selectedVariant.stock === 0}
        >
          <ShoppingBagIcon className="w-5 h-5"/> Sepete Ekle
        </button>
      </div>
    </div>
  );
};


function FavoritesPage() {
  const { favorites } = useFavorites();

  return (
    <div className="bg-gray-50 p-4 sm:p-8 rounded-lg shadow-inner min-h-[60vh]">
      <h1 className="text-3xl font-bold text-text-dark mb-6 border-b pb-4">Favorilerim</h1>
      {favorites.length === 0 ? (
        <div className="text-center py-20">
          <SolidHeartIcon className="w-20 h-20 mx-auto text-gray-300" />
          <p className="mt-4 text-text-light text-xl">Henüz favori ürününüz yok.</p>
          <p className="text-sm text-gray-500">Ürünlerin üzerindeki kalp ikonuna tıklayarak favorilerinize ekleyebilirsiniz.</p>
          <Link to="/" className="mt-6 inline-block bg-brand-green text-white font-bold py-2 px-4 rounded hover:bg-brand-green-light transition-colors">
            Alışverişe Başla
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {favorites.map((product) => (
            <FavoriteProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
}

export default FavoritesPage;